import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './styles.scss';

const propTypes = {
  checked: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  children: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
  header: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

const FancyRadio = ({ checked, children, className, description, header, label, onChange, name, value, ...props }) => {
  const id = `fancy-radio-${value}`;
  return (
    <div className={cn('fancy-radio', className)}>
      {header && <p className="form-group-header">{header}</p>}
      <input
        {...props}
        key={id + '_' + value}
        id={id}
        checked={checked == value}
        onChange={onChange}
        type="radio"
        tabIndex={0}
        name={name}
        value={value}
      />
      <label htmlFor={id}>
        {label && <h4 className="yellow-heading">{label}</h4>}
        {description && <p>{description}</p>}
        {children}
      </label>
    </div>
  );
};

FancyRadio.propTypes = propTypes;

export default FancyRadio;
